import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty, IsBoolean } from 'class-validator';
import { ApiHideProperty, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Transform } from 'class-transformer';

export class InchargeDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @ApiPropertyOptional()
  BoothNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  SerialNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  HNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FirstName:string;
  @ApiProperty()
  @ApiPropertyOptional()
  Surname:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FNTG:string;
  @ApiProperty()
  @ApiPropertyOptional()
  SNTG:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FH:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FHName:string;
  @ApiProperty()
  @ApiPropertyOptional()
  VoterID:string;  
  @ApiProperty()
  @ApiPropertyOptional()
  GENDER:string;
  @ApiProperty()
  @ApiPropertyOptional()
  AGE:string;
  @ApiProperty()
  @ApiPropertyOptional()
  DOB:string;
  @ApiProperty()
  @ApiPropertyOptional()
  VillageID:number;
  @ApiProperty()
  @ApiPropertyOptional()
  Caste:string;
  @ApiProperty()
  @ApiPropertyOptional()
  LocalNonLocal:string;
  @ApiProperty()
  @ApiPropertyOptional()
  NL_Remarks:string;
  @ApiProperty()
  @ApiPropertyOptional()
  MOBILE_NO:string;
  @ApiProperty()
  @ApiPropertyOptional()
  RequestedSchemes:string;
  @ApiProperty()
  @ApiPropertyOptional()
  Party:string;
  @ApiProperty()
  @ApiPropertyOptional()
  Remarks:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FamilyCount:number;
  @ApiProperty()
  @ApiPropertyOptional()
  InchargeUserid:number;
  @ApiProperty()
  @ApiPropertyOptional()
  BenefitsIDs:any;
  @ApiProperty()
  @ApiPropertyOptional()
  InchargeID:number;
  @ApiProperty()
  @ApiPropertyOptional()
  ChildInchargeIds:any;
  @ApiProperty()
  @ApiPropertyOptional()
  ImageLocation?:string;  
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } , description:'upload image type:file'})
  @ApiPropertyOptional()
  Image?:any[];
  @ApiProperty()
  @ApiPropertyOptional()
  GeoLocation:string;  
  @ApiProperty()
  @ApiPropertyOptional()
  IsHOH:number;
  @ApiProperty()
  @ApiPropertyOptional()
  Education:string;
  @ApiProperty()
  @ApiPropertyOptional()
  GraduateYear:number;
  @ApiProperty()
  @ApiPropertyOptional()
  WhatsApp:string;
  @ApiProperty()
  @ApiPropertyOptional()
  PhonePeGPay:string;
  @ApiProperty()
  @ApiPropertyOptional()
  InstaID:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FacebookID:string;
  @ApiProperty()
  @ApiPropertyOptional()
  XID:string;
  @ApiProperty()
  @ApiPropertyOptional()
  ReligionfavoriteGod:string;
  @ApiProperty()
  @ApiPropertyOptional()
  Signature:string;
  @ApiProperty()
  @ApiPropertyOptional()
  SSCCertificate:string;
  @ApiProperty()
  @ApiPropertyOptional()
  GraduateCertificate:string;  
  @ApiProperty()
  @ApiPropertyOptional()
  Aadhar:string;
  @ApiProperty()
  @ApiPropertyOptional()
  Createdby:string;  
  Dateupdated:string;
  @ApiProperty()
  @ApiPropertyOptional()
  UpdatedBy:string;  
  UpdatedDte:string;
  status:number;
}

export class PaginationDto {
  @ApiProperty()
  apiVersion?:number;
  @ApiProperty()
  skip:number;
  @ApiProperty()
  @ApiPropertyOptional()
  VillageID?:number;
  @ApiProperty()
  @ApiPropertyOptional()
  BoothNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  SerialNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  FirstName:string;
  @ApiProperty()
  @ApiPropertyOptional()
  VoterID:string;
  @ApiProperty()
  @ApiPropertyOptional()
  HNo:string
}


export class TransformDto {
  @ApiProperty()
  apiVersion:number;
  @ApiProperty()
  Inchargeid: number;
  @ApiProperty()
  InchargeUserid:number;
}


export class ChildInchargeDto {
  @ApiProperty()
  Inchargeid: number;
  @ApiProperty()
  ChildInchargeIds:any;
  @ApiProperty()
  Createdby: string;
}

